import React from 'react';
import './Legal.css';

function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="back-to-app" onClick={() => window.location.href = '/'}>
          ← Back to AFTERSET
        </button>
        
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 27, 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to AFTERSET ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services at afterset.app (the "Service").</p>
          <p><strong>Operator:</strong> Nicholas Rivera<br/>
          <strong>Contact:</strong> content.nr17@gmail.com<br/>
          <strong>Location:</strong> Illinois, United States</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          
          <h3>2.1 Information You Provide</h3>
          <ul>
            <li><strong>Account Information:</strong> Email address, password (encrypted)</li>
            <li><strong>Payment Information:</strong> Processed securely through Stripe (we never store full payment details)</li>
            <li><strong>Content:</strong> Photos and videos you upload to organize your festival memories</li>
            <li><strong>Profile Data:</strong> Festival tags, dates, and location data you choose to add</li>
          </ul>

          <h3>2.2 Automatically Collected Information</h3>
          <ul>
            <li><strong>Device Information:</strong> Browser type, device type, operating system</li>
            <li><strong>Usage Data:</strong> Pages visited, features used, time spent on Service</li>
            <li><strong>Location Data:</strong> GPS coordinates from photo metadata (only if present in uploaded files)</li>
            <li><strong>Cookies:</strong> We use essential cookies for authentication and Service functionality</li>
          </ul>

          <h3>2.3 Information from Third Parties</h3>
          <ul>
            <li><strong>Stripe:</strong> Payment processing and subscription status</li>
            <li><strong>Firebase (Google):</strong> Authentication, database, and file storage services</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide, operate, and maintain the Service</li>
            <li>Process your payments and manage subscriptions</li>
            <li>Organize and display your festival memories</li>
            <li>Detect and suggest festivals based on photo metadata</li>
            <li>Send service-related communications (password resets, payment confirmations)</li>
            <li>Improve and optimize the Service</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Storage and Security</h2>
          
          <h3>4.1 Where We Store Data</h3>
          <ul>
            <li><strong>Photos/Videos:</strong> Stored securely on Firebase Cloud Storage (Google Cloud Platform)</li>
            <li><strong>User Data:</strong> Stored on Firebase Firestore database</li>
            <li><strong>Payment Data:</strong> Handled by Stripe (PCI DSS compliant)</li>
          </ul>

          <h3>4.2 Security Measures</h3>
          <ul>
            <li>Encrypted data transmission (SSL/TLS)</li>
            <li>Secure password hashing</li>
            <li>Regular security updates</li>
            <li>Access controls and authentication</li>
          </ul>

          <h3>4.3 Data Retention</h3>
          <ul>
            <li><strong>Active accounts:</strong> Data retained while your account is active</li>
            <li><strong>Deleted accounts:</strong> Data permanently deleted within 30 days of account deletion</li>
            <li><strong>Legal requirements:</strong> Some data may be retained longer if required by law</li>
          </ul>
        </section>

        <section>
          <h2>5. How We Share Your Information</h2>
          <p>We do <strong>NOT</strong> sell your personal information. We share data only in these limited circumstances:</p>
          
          <h3>5.1 Service Providers</h3>
          <ul>
            <li><strong>Firebase/Google:</strong> Cloud hosting and authentication</li>
            <li><strong>Stripe:</strong> Payment processing</li>
            <li><strong>Vercel:</strong> Website hosting</li>
          </ul>

          <h3>5.2 Legal Requirements</h3>
          <p>We may disclose information if required by law, court order, or government request.</p>

          <h3>5.3 Business Transfers</h3>
          <p>If AFTERSET is acquired or merged, your data may be transferred to the new entity.</p>
        </section>

        <section>
          <h2>6. Your Privacy Rights</h2>
          <p>Depending on your location, you may have these rights:</p>
          
          <h3>6.1 Access and Portability</h3>
          <ul>
            <li>Request a copy of your data</li>
            <li>Export your photos and festival data</li>
          </ul>

          <h3>6.2 Correction</h3>
          <ul>
            <li>Update your account information</li>
            <li>Correct inaccurate data</li>
          </ul>

          <h3>6.3 Deletion</h3>
          <ul>
            <li>Delete your account and all associated data</li>
            <li>Request removal of specific memories</li>
          </ul>

          <p><strong>To exercise these rights, contact us at content.nr17@gmail.com</strong></p>
        </section>

        <section>
          <h2>7. Children's Privacy</h2>
          <p>AFTERSET is not intended for users under 13 years old. We do not knowingly collect data from children under 13. If we learn we have collected such data, we will delete it promptly.</p>
        </section>

        <section>
          <h2>8. International Users</h2>
          <p>AFTERSET is operated from the United States. If you access the Service from outside the U.S., your data may be transferred to and processed in the United States. By using the Service, you consent to this transfer.</p>
        </section>

        <section>
          <h2>9. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page and updating the "Last Updated" date. Your continued use of the Service after changes constitutes acceptance of the updated policy.</p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <p>If you have questions or concerns about this Privacy Policy or our data practices:</p>
          <p>
            <strong>Email:</strong> content.nr17@gmail.com<br/>
            <strong>Operator:</strong> Nicholas Rivera<br/>
            <strong>Service:</strong> AFTERSET (afterset.app)<br/>
            <strong>Location:</strong> Illinois, United States
          </p>
          <p>We will respond to all requests within 30 days.</p>
        </section>

        <div className="acknowledgment">
          <p>By using AFTERSET, you acknowledge that you have read and understood this Privacy Policy.</p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
